module.exports = __webpack_public_path__ + "static/home_bodegon-21db8844d0dd1bb70719bf948c1d8bf1.png";